/**
 * PRIMEO — Shopify Theme JavaScript
 * Interactions, animations, and UI logic
 */

(function () {
    'use strict';

    // ==========================================
    // Header Scroll Effect
    // ==========================================
    const header = document.getElementById('siteHeader');
    const backToTop = document.getElementById('backToTop');

    if (header || backToTop) {
        window.addEventListener('scroll', function () {
            const scrollY = window.scrollY;
            if (header) header.classList.toggle('scrolled', scrollY > 50);
            if (backToTop) backToTop.classList.toggle('visible', scrollY > 400);
        });
    }

    if (backToTop) {
        backToTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // ==========================================
    // Mobile Menu
    // ==========================================
    const mobileToggle = document.getElementById('mobileToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileClose = document.getElementById('mobileClose');

    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', function () {
            mobileMenu.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    }

    if (mobileClose && mobileMenu) {
        mobileClose.addEventListener('click', function () {
            mobileMenu.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    if (mobileMenu) {
        mobileMenu.addEventListener('click', function (e) {
            if (e.target === mobileMenu) {
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
    }

    // ==========================================
    // Search Panel
    // ==========================================
    const searchToggle = document.getElementById('searchToggle');
    const searchPanel = document.getElementById('searchPanel');
    const searchPanelClose = document.getElementById('searchPanelClose');
    const searchPanelInput = document.getElementById('searchPanelInput');

    if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', function () {
            searchPanel.classList.add('active');
            setTimeout(function () {
                if (searchPanelInput) searchPanelInput.focus();
            }, 200);
        });
    }

    if (searchPanelClose && searchPanel) {
        searchPanelClose.addEventListener('click', function () {
            searchPanel.classList.remove('active');
        });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchPanel) {
            searchPanel.classList.remove('active');
        }
    });

    // ==========================================
    // Reveal on Scroll (IntersectionObserver)
    // ==========================================
    const revealElements = document.querySelectorAll('.reveal');
    if (revealElements.length > 0 && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

        revealElements.forEach(function (el) {
            observer.observe(el);
        });
    }

    // ==========================================
    // Product Filter Buttons (Collection Pages)
    // ==========================================
    const filterBtns = document.querySelectorAll('.filter-btn');
    if (filterBtns.length > 0) {
        filterBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                filterBtns.forEach(function (b) { b.classList.remove('active'); });
                btn.classList.add('active');
                var filterVal = btn.dataset.filter;
                var cards = document.querySelectorAll('.product-card[data-category]');
                cards.forEach(function (card) {
                    card.style.display = (filterVal === 'all' || card.dataset.category === filterVal) ? '' : 'none';
                });
            });
        });
    }

    // ==========================================
    // Product Thumbnails Gallery — géré directement
    // dans product-page.liquid (swap haute résolution)
    // ==========================================

    // ==========================================
    // Size Buttons — géré directement dans
    // product-page.liquid (sélection de variante)
    // ==========================================

    // ==========================================
    // Quantity Selector — géré directement dans
    // product-page.liquid et main-cart.liquid
    // (retiré ici pour éviter le double incrément)
    // ==========================================

    // ==========================================
    // Tabs (Product Page) — géré directement dans
    // product-page.liquid
    // ==========================================

    // ==========================================
    // FAQ Accordion
    // ==========================================
    const faqItems = document.querySelectorAll('.faq-question');
    if (faqItems.length > 0) {
        faqItems.forEach(function (question) {
            question.addEventListener('click', function () {
                var item = question.parentElement;
                var wasOpen = item.classList.contains('open');
                document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
                if (!wasOpen) item.classList.add('open');
            });
        });
    }

    // ==========================================
    // Color Swatches
    // ==========================================
    const swatches = document.querySelectorAll('.swatch');
    if (swatches.length > 0) {
        swatches.forEach(function (swatch) {
            swatch.addEventListener('click', function () {
                swatches.forEach(function (s) { s.classList.remove('active'); });
                swatch.classList.add('active');
            });
        });
    }

    // ==========================================
    // Favoris (Wishlist) — sauvegardé dans le navigateur
    // ==========================================
    (function () {
        var STORAGE_KEY = 'primeo_wishlist';

        function getWishlist() {
            try {
                return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
            } catch (e) {
                return [];
            }
        }

        function saveWishlist(list) {
            try {
                window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
            } catch (e) { /* stockage indisponible (navigation privée, etc.) */ }
        }

        function setButtonState(btn, active) {
            var icon = btn.querySelector('i');
            btn.classList.toggle('active', active);
            if (icon) {
                icon.classList.toggle('far', !active);
                icon.classList.toggle('fas', active);
            }
        }

        var wishlistBtns = document.querySelectorAll('[data-wishlist-id]');
        if (wishlistBtns.length === 0) return;

        var wishlist = getWishlist();
        wishlistBtns.forEach(function (btn) {
            setButtonState(btn, wishlist.indexOf(btn.dataset.wishlistId) !== -1);

            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var id = btn.dataset.wishlistId;
                var current = getWishlist();
                var idx = current.indexOf(id);
                var nowActive;

                if (idx === -1) {
                    current.push(id);
                    nowActive = true;
                } else {
                    current.splice(idx, 1);
                    nowActive = false;
                }

                saveWishlist(current);

                // Met à jour tous les boutons du même produit sur la page (fiche + grille)
                document.querySelectorAll('[data-wishlist-id="' + id + '"]').forEach(function (b) {
                    setButtonState(b, nowActive);
                });
            });
        });
    })();

})();
